export default __webpack_public_path__ + "static/media/photo--lg--69.b4227872.jpg";